/** Presentation data only. Callers supply rewards from an already validated grant. */
export interface RewardCollectionItemData {
    id: string;
    /** A translated reward name, also used when artwork cannot be loaded. */
    label: string;
    /** Exact, non-negative integer minor units. Never convert balances to Number. */
    amount: string;
    decimalScale: number;
    imageUrl?: string;
}

export interface RewardCollectionPresentation {
    /** Unique per presentation. Changing this ID starts a fresh animation/timer. */
    id: string;
    rewards: readonly RewardCollectionItemData[];
}

export type RewardCollectionReason = "tap" | "timeout" | "dismiss";
export type RewardCollectionPhase =
    "entering" | "visible" | "exiting" | "closed";

// Clip shapes come from the APK; playback durations match the supplied recording.
export const REWARD_COLLECTION_TIMING = {
    autoCollectMs: 3_000,
    revealDelayMs: 360,
    revealMs: 300,
    backdropInMs: 250,
    itemsOutMs: 400,
    itemStaggerMs: 30,
    backdropOutMs: 125,
} as const;

export function rewardCollectionTimeout(value: number | null): number | null {
    if (value === null) return null;
    const duration = Number.isFinite(value)
        ? value
        : REWARD_COLLECTION_TIMING.autoCollectMs;
    // Allow the reward reveal to finish and stay within the browser timer range.
    return Math.min(
        2_147_483_647,
        Math.max(REWARD_COLLECTION_TIMING.revealMs, duration),
    );
}
